export const isValidJSON = (str) => {
    try {
        JSON.parse(str);

        return true;
    } catch (e) {
        return false;
    }
}

export const getProps = (props) => isValidJSON(props) ? JSON.parse(props || "{}") : props;

export const renderProps = (props) => {
    if (Array.isArray(props)) {
        return { data: props };
    } else if (typeof props === "object" && props !== null) {
        return props;
    } else {
        return { value: props };
    }
}
